import { TIMELINE_EVENTS } from "@/mocks/home";
import SectionHeader from "./SectionHeader";

const typeColor: Record<string, string> = {
  爆点: "bg-primary-500 text-background-50",
  实锤: "bg-accent-500 text-foreground-950",
  跟进: "bg-secondary-200 text-secondary-900",
  线索: "bg-secondary-100 text-secondary-900",
};

export default function Timeline() {
  return (
    <section id="timeline" className="bg-background-50 py-14 md:py-20">
      <SectionHeader
        eyebrow="吃瓜时间线 / TIMELINE"
        title="本月大瓜爆点，一条线看懂来龙去脉"
        desc="从线索初现到实锤落地，按日期串联本月大瓜关键节点，帮你在几秒内补完全程，不再错过任何重点。"
        accent
      />

      <div className="mx-auto mt-10 max-w-4xl px-4 md:px-6">
        <ol className="relative ml-2 border-l-2 border-dashed border-secondary-300 md:ml-4">
          {TIMELINE_EVENTS.map((e) => (
            <li key={e.id} className="relative mb-8 pl-8 last:mb-0 md:pl-12">
              <span className="absolute top-1 -left-[9px] flex h-4 w-4 items-center justify-center rounded-full border-2 border-background-50 bg-accent-500" />
              <div className="flex flex-col gap-1 rounded-2xl border border-background-200 bg-background-100 p-5 sm:flex-row sm:items-start sm:justify-between">
                <div className="sm:pr-4">
                  <span className={`inline-flex rounded-md px-2 py-0.5 text-[11px] font-bold ${typeColor[e.type]}`}>
                    {e.type}
                  </span>
                  <h3 className="font-heading mt-2 text-base font-bold text-foreground-950">{e.title}</h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{e.desc}</p>
                </div>
                <span className="shrink-0 text-left text-sm font-bold whitespace-nowrap text-primary-700 sm:text-right">
                  {e.date}
                </span>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}